import React from 'react'

function UserList() {
  return (
    <div style={{flex:4}}>
      <h2>User List</h2>
    </div>
  )
}

export default UserList
